module.exports = __webpack_public_path__ + "media/images/icons/three-dot-637fc774f076a5d030a6f378885de54f.svg";